import { LogDelta, logFieldValue } from "@/entities/history/types";

// Reference fields arrive either scalar (parent_partner) or array-valued
// (partner_contacts); normalize so one renderer covers both. Deduped so a
// repeated id renders one name rather than "Acme, Acme".
export const toIdList = (value: logFieldValue): string[] => {
  if (value === null || value === undefined || value === "") return [];
  const values = Array.isArray(value) ? value : [value];
  return [...new Set(values.map(String).filter(Boolean))];
};

export const getPeopleIdsDelta = (logDelta: LogDelta | null): string[] => {
  const fieldDelta = logDelta?.manuallyAddedPeople;
  if (!fieldDelta || fieldDelta.length === 0) return [];

  const [previousPeople, currentPeople] = fieldDelta[0];
  const previousIds = toIdList(previousPeople);
  return toIdList(currentPeople).filter((id) => !previousIds.includes(id));
};
